<template>
    
        <span class='price'>
            R$ {{getPrice}}
        </span>

</template>

<script>
export default {
    props:{
        price:{
            default:0
        }
    },
    computed:{
        getPrice:function(){
            if(this.$slots.default){
                return this.$slots.default
            }else{
                return this.price
            }
        }
    }

}
</script>

<style lang="stylus">

</style>
